import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ValidDatos.css";
import ValidDatosEj from "../../images/validDatosEj.png";
import ValidDatosForm from "../../components/validDatosForm/ValidDatosForm.js";
import Swal from "sweetalert2";
import { getProveedorByNroCta } from "../../api/abmProvider.js";

// Iconos
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
//Rutas
import Routes_gral from "../../utils/Routes_gral.js";

//Contexts
import agregarSoliAjusContext from "../../context/agregarSoliAjus/agregarSoliAjusContext.js";
import authContext from "../../context/authentication/authContex.js";

const ValidDatos = ({
  edicion,
  item,
  files = [],
  guardarSolicitud,
  cerrar,
  verDetalle,
}) => {
  const [solicitud, setSolicitud] = useState(item || {});
  //State de los archivos seleccionados.
  const [selectedFiles, setSelectedFiles] = useState(files);
  const [deleteOnTouch, setDeleteOnTouch] = useState(false);
  const [proveedor, setProveedor] = useState({});
  const [controlBotonEnviar, setControlBotonEnviar] = useState(false);

  //Context de Autenticacion
  const aContext = useContext(authContext);
  const { usuario } = aContext;

  //Context agregar requerimiento
  const addSoliAjusContext = useContext(agregarSoliAjusContext);
  const { soliAjus, guardarSolicitudAjuste } = addSoliAjusContext;

  const navigate = useNavigate();

  useEffect(() => {
    const fn = async () => {
      const resp = await getProveedorByNroCta(usuario.nroCta);
      if (resp.data.data) {
        setProveedor(resp.data.data);
      }
    };
    fn();
  }, []);

  const handleChange = (e) => {
    setSolicitud({ ...solicitud, [e.target.name]: e.target.value });
  };

const handleFileInputChange = (e) => {
  if (e.target.files.length === 0) return;

  const newFiles = Array.from(e.target.files);
  const maxFileSize = 50 * 1024 * 1024; // 50 MB en bytes

  const filesToAdd = [];
  let fileTooLarge = false;

  // Filtramos archivos nuevos que no estén ya en la lista actual
  const uniqueNewFiles = newFiles.filter(
    (newFile) =>
      !selectedFiles.some(
        (existingFile) => existingFile.name === newFile.name
      )
  );

  uniqueNewFiles.forEach((newFile) => {
    // Validar si el archivo excede el tamaño máximo permitido
    if (newFile.size > maxFileSize) {
      fileTooLarge = true;
      Swal.fire({
        icon: "error",
        title: "Tamaño de archivo excedido",
        text: `El archivo "${newFile.name}" es demasiado grande. El tamaño máximo permitido es de 50MB.`,
      });
    } else {
      filesToAdd.push(newFile);
    }
  });

  if (!fileTooLarge) {
    setSelectedFiles([...selectedFiles, ...filesToAdd]);

    // Notificar al usuario si se omitieron archivos duplicados
    if (uniqueNewFiles.length < newFiles.length) {
      Swal.fire({
        icon: "info",
        title: "Archivo duplicado",
        text: "Algunos archivos ya estaban agregados y fueron omitidos.",
      });
    }
  }

  // Limpiar el input para poder seleccionar los mismos archivos nuevamente si es necesario
  e.target.value = null;
};

  const validate = (solicitud, files) => {
    let resp = "";

    if (
      (solicitud.notePubl === "" || solicitud.notePubl == undefined)
    ) {
      resp = "Ingrese los ajustes a realizar.";
    }
    return resp;
  };

  const handleSaveSolicitud = async () => {
    try {
    let validation = validate(solicitud, selectedFiles);

    if (validation == "") {
      setControlBotonEnviar(true); // Bloqueo el botón mientras se esta enviando el comprobante.

      if (edicion === "Edicion") {
        await guardarSolicitud(solicitud, selectedFiles);
        setControlBotonEnviar(false); // Habilitar el botón nuevamente
        cerrar();
      } else {
          let resp = await guardarSolicitudAjuste(
            solicitud,
            usuario,
            selectedFiles
          );
          Swal.fire({
            title: `Se creó la ${resp.soliAjusCodFor} - ${resp.soliAjusNroFor}`,
            text: `Puede hacer el seguimiento de su solicitud accediendo al panel de solicitudes desde la barra inferior de Navegación.`,
            icon: "success",
            showConfirmButton: true,
            allowEnterKey: true,
          });
          setSolicitud({ ...item });
          setSelectedFiles([]);
      }
      navigate("/solicitudes");
    } else {
      setControlBotonEnviar(false); // Habilitar el botón nuevamente
      Swal.fire({
        title: "Hubo un error en la validación!",
        text: validation,
        icon: "error",
      });
    }
    } catch (error) {
          await Swal.fire({
            title: "Error al guardar solicitud de ajuste",
            text:
              error?.response?.data?.message ||
              error?.message ||
              "Ocurrió un error inesperado",
            icon: "error",
          });
        } finally {
          setControlBotonEnviar(false);
        }
  };

  const handleRemoveFile = (fileName) => {
    const array = Array.from(selectedFiles);
    setSelectedFiles(array.filter((data) => data.name !== fileName));
  };

  const handleClickImgPrev = (url = "", name = "") => {
    if (deleteOnTouch) {
      handleRemoveFile(name);
    } else {
      window.open(url, "_blank");
    }
  };

  return (
    <div className="validDatosDiv">
      <div
        className="asideFunctions"
        style={{ height: window.innerHeight - 210 }}
      >
        {edicion && (
          <>
            <h5 className="tituloNotas">Notas Administración:</h5>
            <textarea
              disabled
              id="inputNotasAdministracion"
              name="notePriv"
              value={solicitud.notePriv}
            />
            <h5 className="tituloNotas">Notas Proveedor:</h5>
          </>
        )}
        <textarea
          id="inputCorreccionDatos"
          style={{ height: edicion ? "100px" : "150px" }}
          name="notePubl"
          onChange={(e) => handleChange(e)}
          value={solicitud.notePubl}
          placeholder="Indique ajuste a realizar"
        />
        <div id="inputFileDiv">
          <input
            type="file"
            aria-label="Agregar Archivo"
            multiple
            onChange={(e) => handleFileInputChange(e)}
          />
        </div>
        <label style={{ display: "none" }} className="checkboxLabel">
          Eliminar al tocar{" "}
          <input
            type="checkbox"
            onChange={(e) => setDeleteOnTouch(e.target.checked)}
          />
        </label>

        <div className="container-new-files">
          <ul className="container-new-files-details">
            {selectedFiles.length > 0 &&
              selectedFiles.map((file) => (
                <li key={file.name}>
                  {file.name}
                  <FontAwesomeIcon
                    onClick={() => handleRemoveFile(file.name)}
                    style={{
                      cursor: "pointer",
                      color: "red",
                      marginLeft: "20px",
                    }}
                    icon={faXmark}
                  />
                </li>
              ))}
          </ul>
        </div>
        <button
          className={`btnValidDatos ${controlBotonEnviar ? "disabled" : ""}`}
          id="btnSendFixReq"
          disabled={controlBotonEnviar}
          onClick={handleSaveSolicitud}
        >
          Enviar solicitud <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </div>
      <div className="mainData">
        <ValidDatosForm proveedor={proveedor} usuario={usuario} />
      </div>
      <div>
        {edicion ? (
          <FontAwesomeIcon
            size="2x"
            style={{
              cursor: "pointer",
              marginLeft: "10px",
              marginTop: "-10px",
            }}
            icon={faXmark}
            onClick={() => cerrar(null)}
          />
        ) : (
          <FontAwesomeIcon
            size="2x"
            style={{
              cursor: "pointer",
              marginLeft: "10px",
              marginTop: "-10px",
            }}
            icon={faXmark}
            onClick={() => navigate("/solicitudes")}
          />
        )}
      </div>
    </div>
  );
};

export default ValidDatos;